import useCart from "grandus-lib/hooks/useCart";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import filter from "lodash/filter";
import { Alert } from "antd";

import { CART_TOP_MESSAGES_HASH } from "constants/CartConstants";

const CartTopMessages = () => {
  const { cart } = useCart();

  const cartMessages = filter(cart?.messages, {
    hash: CART_TOP_MESSAGES_HASH,
  });

  if (isEmpty(cartMessages)) {
    return null;
  }

  return (
    <>
      {map(cartMessages, (message, index) => (
        <Alert
          key={`top-cart-message-${index}`}
          message={
            <div
              dangerouslySetInnerHTML={{ __html: message.text }}
            />
          }
          type="success"
          style={{ marginBottom: "5px" }}
        />
      ))}
    </>
  );
};

export default CartTopMessages;
